/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */
import { initCartQuantity } from "./cart-quantity";
import { initFormKey } from "./formKey";
import { initGlobalMessages } from "./global-message-list";
import { initLimiter } from "./limiter";
import { initMenu } from "./menu";
import { initMobileMenu } from "./mobile-menu";
import { initReCaptcha } from "./recaptcha";
import { initSearch } from "./search";

export function initTheme() {
    initFormKey();
    initGlobalMessages();
    initMenu();
    initMobileMenu();
    initSearch();
    initCartQuantity();
    initLimiter();
    initReCaptcha();
}
